export const novedadesReleaseMapper = (data: any) => {
  return {
    ...data,
    application: data.application?.value || data.application,
    features: data.features?.map((f: any) => ({
      ...f,
      type: f.type?.value || f.type,
    })),
  };
};

export const novedadesReleaseToFormMapper = (data: any, formInitialValues: any) => {
  if (!data) return null;

  return {
    version: data.version || '',
    application: data.application
      ? { label: data.application.name, value: data.application.id }
      : null,
    features:
      data.features?.length > 0
        ? data.features.map((f: any) => ({
            moduleName: f.moduleName || '',
            title: f.title || '',
            description: f.description || '',
            type: f.type || null,
          }))
        : formInitialValues.features,
  };
};
